import { data } from '../../svg/AccountCircleOff/data';
import { makeIcon } from '../makeIcon';

export const AccountCircleOff = makeIcon(data, 'account_circle_off', 'AccountCircleOff');

export default AccountCircleOff;
